import { Reveal } from "./Reveal";

const chapters = [
  {
    nr: "01",
    title: "Alleen betaalbaar aanbod",
    text: "Wij selecteren uitsluitend huurwoningen onder de liberalisatiegrens en in het middensegment. Geen pachtprijzen, geen verassingen achteraf.",
  },
  {
    nr: "02",
    title: "Eerlijke prijzen, altijd",
    text: "Geen inschrijfkosten, geen courtage, geen verborgen 'servicekosten'. De huurprijs die je ziet is de huurprijs die je betaalt.",
  },
  {
    nr: "03",
    title: "Direct reageren, snel antwoord",
    text: "Zie je een woning die past? Reageer direct via het formulier. Wij nemen binnen 24 uur contact met je op — persoonlijk, geen bots.",
  },
];

export const Manifesto = () => {
  return (
    <section
      id="over-ons"
      data-testid="manifesto-section"
      className="py-24 md:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <Reveal>
          <p className="text-xs md:text-sm tracking-[0.3em] uppercase text-muted-foreground mb-6">
            Ons manifest
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display font-black text-3xl md:text-5xl lg:text-6xl tracking-tight leading-none max-w-3xl">
            Huren moet weer eerlijk worden.
          </h2>
        </Reveal>

        <div className="mt-20 md:mt-32 grid grid-cols-1 md:grid-cols-12 gap-y-16 md:gap-x-8">
          {chapters.map((c, i) => (
            <Reveal
              key={c.nr}
              delay={0.1 * i}
              className={`md:col-span-4 ${
                i === 1 ? "md:mt-24" : i === 2 ? "md:mt-48" : ""
              }`}
            >
              <div className="border-t-2 border-foreground pt-6">
                <span className="font-display font-black text-6xl md:text-7xl text-foreground/10 leading-none">
                  {c.nr}
                </span>
                <h3 className="font-display font-bold text-xl md:text-2xl tracking-tight mt-4">
                  {c.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed mt-4 max-w-sm">
                  {c.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <div
            data-testid="about-arthur-block"
            className="mt-24 md:mt-32 border border-border bg-card p-8 md:p-10 flex flex-col sm:flex-row items-start sm:items-center gap-8"
          >
            <img
              data-testid="about-arthur-photo"
              src="/arthur.png"
              alt="Arthur — oprichter van Rent Guru"
              className="w-48 h-48 md:w-56 md:h-56 object-cover border border-border"
            />
            <div>
              <p className="text-xs tracking-[0.25em] uppercase text-muted-foreground">
                Jouw makelaar
              </p>
              <h3 className="font-display font-black text-2xl md:text-3xl tracking-tight mt-2">
                Arthur — oprichter van Rent Guru
              </h3>
              <p className="text-muted-foreground leading-relaxed mt-3 max-w-xl">
                Meer dan 10 jaar ervaring in de verhuurmarkt. Ik ken de markt,
                de verhuurders en de valkuilen — en zorg dat jij eerlijk en
                snel aan een betaalbare woning komt.
              </p>
              <a
                data-testid="about-arthur-email-link"
                href="mailto:arthur@rentguru.nl"
                className="inline-block mt-4 text-sm font-medium underline underline-offset-4 hover:text-muted-foreground transition-colors duration-200"
              >
                arthur@rentguru.nl
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
